import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { styled } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

import { Icon } from '../../Icon/Icon'

export type IconTextGridCellProps = GridRenderCellParams & {
  //
}

export type IconTextGridCellValueType = {
  text?: string
  icon: IconDefinition
  uiColor: string
}

export const IconTextGridCell: React.FC<IconTextGridCellProps> = ({ value }) => {
  return (
    <StyledContainer>
      <StyledIcon icon={value.icon} $color={value.uiColor} />
      {value.text}
    </StyledContainer>
  )
}

const StyledContainer = styled('div')`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
`

const StyledIcon = styled(Icon, { shouldForwardProp: (prop) => prop !== '$color' })<{ $color: string }>`
  color: ${props => props.$color};
  font-size: 18px;
  margin-right: 5px;
`